import { Component, ComponentRef, Type, ViewChild, effect, signal, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { ClientDetailComponent } from '../client-detail/client-detail.component';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { LookupProfile } from '@app/common-codes/services/LookupService';
import { INeedRefreshData, IRefreshDateRangeValue } from '@app/common-codes/components/_primitives/INeedRefreshData';
import { ToInstantString } from '@app/common-codes/helpers/dateHelpers';
import { StructuredDataRequest } from '@app/common-codes/_DTOs/IStructuredData';

@Register(Client)
@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    ClientDetailComponent,
    ListTableColumnComponent,
    TranslatePipe
]
})
export class ClientListComponent extends GenericListComponent<Client> {
  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = Client;
  override entityMetaData: IEntityMetaData = new Client().GetType();

 // override dataMode = 'store' as const;
  override contextMenuItems = []; // pour annuler le context-menu
  // isModalOpen = signal(false); // Renommé pour refléter l'usage (create + edit)
  modalEntity = signal<Client | null>(null);
  @ViewChild('clientDetail', { read: ClientDetailComponent }) clientDetail!: ClientDetailComponent;

  public static override get lookupProfiles(): LookupProfile[] {
    return [];  // 
  }



  constructor(_alertModalService: AlertModalService) {
    super();


    this.alertModalService = _alertModalService;
    effect(() => {
      if (this.listView()?.entities()?.total === 1) {
        // this.listView()?.selectedId.set((this.listView()?.entities()?.items[0] as Client).id);
        this.listView()?.onTableEntitySelected((this.listView()?.entities()?.items[0] as Client).id);
      }
    })
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    // Déclencher la recherche dans le list-view
    this.listView()?.onSearch(value);
  }

  override ngOnInit() {
    super.ngOnInit();

    let uuu = this.RequiredPermissions;
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();

  }

  override getdetailComponent(): GenetricDetailComponent<Client> | undefined {
    return this.clientDetail;
  }

  override async refreshData(needRefreshData: INeedRefreshData): Promise<void> {
    if (needRefreshData.filterType === 'dateTime') {

      const params: StructuredDataRequest = {
        pageNumber: this.cachePage,
        pageSize: this.cacheSize,
        search: this.listView()?.searchTerm() || '',
        sortBy: this.listView()?.sortBy() || '',
        sortOrder: this.listView()?.sortOrder() || 'asc',
        combinedSearchColumns: this.listView()?.getPagination().searchColumns?.join(',') || '',
        requiredLookups: undefined,
        dateRange: [{
          startDate: ToInstantString((needRefreshData.value as IRefreshDateRangeValue).startDate),
          endDate: ToInstantString((needRefreshData.value as IRefreshDateRangeValue).endDate),
          entityName: needRefreshData.entityName,
          columnName: needRefreshData.columnName
        }],
        featureContext: this.featureContext,
        includedEntities: this.mediator?.entityNames(),
        filters: this.filterStateService.filtersFor(this.mediator?.nestedListKeys() ?? [])
      };

      await this.performLoadData(params, 0, this.cacheSize);

      const currentRoot = this.mediator?.selectedRoot();
      this.mediator?.selectedRoot.set(null);
      this.mediator?.selectedLevel1.set(null);
      const foundItem = this.cache.find(c => c.id === currentRoot?.id);
      if (foundItem) {
        this.mediator?.selectRoot(foundItem); 
      } else {
        this.mediator?.selectRoot(null);
      }
    }
  }

}
